module.exports = __webpack_public_path__ + "static/media/seal.7a6ff62c.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/ID/seal.png
// module id = 1503
// module chunks = 0